import { Link } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";

const Shell = ({ children, tagline }) => (
  <div className="relative z-10 min-h-screen grid lg:grid-cols-2">
    <aside className="hidden lg:flex flex-col justify-between p-12 border-r border-white/10 bg-[#0A0A0A]">
      <div className="flex items-center gap-3">
        <span className="w-9 h-9 bg-[#CCFF00] text-black font-display font-extrabold text-xl flex items-center justify-center">A</span>
        <span className="font-display text-2xl font-bold uppercase tracking-wide">Apito<span className="text-[#CCFF00]">.</span>Registo</span>
      </div>
      <div>
        <h1 className="font-display text-6xl font-bold uppercase leading-[0.9]">Cada lance,<br /><span className="text-[#CCFF00]">ao segundo.</span></h1>
        <p className="text-zinc-400 mt-6 max-w-md">{tagline}</p>
      </div>
      <p className="text-xs text-zinc-600">Os seus jogos só são visíveis na sua conta.</p>
    </aside>
    <main className="flex flex-col items-center justify-center p-4 py-10 gap-6">
      <div className="lg:hidden flex items-center gap-3">
        <span className="w-8 h-8 bg-[#CCFF00] text-black font-display font-extrabold text-lg flex items-center justify-center">A</span>
        <span className="font-display text-xl font-bold uppercase tracking-wide">Apito<span className="text-[#CCFF00]">.</span>Registo</span>
      </div>
      {children}
    </main>
  </div>
);

export const SignInPage = () => (
  <Shell tagline="Inicie sessão para registar jogos e consultar os seus relatórios.">
    <div data-testid="sign-in-page"><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></div>
    <p className="text-sm text-zinc-400">Não tem conta? <Link to="/sign-up" data-testid="go-sign-up" className="text-[#CCFF00] font-semibold hover:underline">Registar</Link></p>
  </Shell>
);

export const SignUpPage = () => (
  <Shell tagline="Crie a sua conta com email. Receberá um código para confirmar o registo antes de entrar.">
    <div data-testid="sign-up-page"><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></div>
  </Shell>
);
